import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Formsy from 'formsy-react';
import Tag from '../../forms/Tag';
import CheckBox from '../../forms/CheckBox';
import FieldError from '../../forms/FieldError'
import withBaseComponent from '../../withBaseComponent';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import { trackingEvent } from "../../pages/layouts/GoogleAnalytics.js"

class SubAccount extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props)

    const {tags} = this.props
    this.state = {
      tags: tags || [],
      isOpenModal: false,
      message: "",
      newTagValue: ""
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.addNewTag = this.addNewTag.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.trackingSetting = this.trackingSetting.bind(this)
  }

  trackingSetting() {
    trackingEvent("Bank", "サブアカウント設定")
    this.toggleModal()
  }

  addTag(tag) {
    this.props.userActions.addTag({tag: {name: tag}})
    .then((response) => {
      this.addNewTagState()
    })
    .catch(error => {
      if(error && error.status && error.status === 422 && error.data.errors.name) {
        this.setState({hasError: true, message: error.data.errors.name})
      }
    });
  }

  removeTag(tag) {
    let tags = this.state.tags
    tags.delete(tag)
    this.setState({tags: tags})
  }

  addNewTag(e) {
    if (this.validTag(this.state.newTagValue)) {
      this.addTag(this.state.newTagValue)
    }

    e.preventDefault()
    e.stopPropagation()
  }

  onKeyPress = (e) => {
    if (e.key === 'Enter'){
      this.addNewTag(e)
    }
  }

  validTag(value) {
    if (value.trim() === "") {
      this.setState({hasError: true, message: i18n.t('validations.required')})
      return false
    }

    if (value.length > 20) {
      this.setState({hasError: true, message: i18n.t('validations.tags.name')})
      return false
    }

    return true
  }

  addNewTagState() {
    this.setState({
      hasError: false,
      message: '',
      newTagValue: ''
    })
  }

  onSubmit(model) {
    let {tags, is_target} = model
    const {item, account} = this.props
    tags = tags && tags.filter(tag => tag.selected)

    const data = {
      account_id: account.id,
      evora_sub_account_id: item.id,
      is_target: is_target || 0,
      sub_account_tags_attributes: tags && tags.map(tag => { return {tag_id: tag.id} })
    }

    this.props.accountActions.subAccountUpdate(account.id, item.id, data)
      .then(() => this.setState({isOpenModal: false}))
  }

  data_tags() {
    let {tags} = this.props
    const tagIds = this.props.item.tags.map(tag => tag.id)

    return tags.map(tag => {
      tag["active"] = tagIds.includes(tag.id)

      return tag
    })
  }

  toggleModal() {
    super.toggleModal()
    this.addNewTagState()
  }

  handleChange(event) {
    this.setState({newTagValue: event.target.value});
  }

  render() {
    const {item, hasBottomLine, account} = this.props
    let is_target_label = ""

    if(item.is_target === 0 || item.is_target === null){
      is_target_label = i18n.t('bank.item_bank.has_no_target')
    } else if(item.is_target === 1){
      is_target_label = i18n.t('bank.item_bank.has_target')
    }

    return (
      <div className={`col-sm-12 item-row row ${!hasBottomLine ? 'no-bottom-line' : ''}`}>
        <div className="col-sm-4 name">
          <span>{[item.name, item.type, item.number].join(" ")}</span>
        </div>
        <div className="col-sm-2 status">
          {!account.is_suspended && <span>{is_target_label}</span>}
        </div>
        <div className="col-sm-4 tag no-margin">
          {this.props.item.tags.map((tag, i) => <span key={`id${tag.id}`} className="label label-status">{tag.name}</span>)}
        </div>
        <div className={"col-sm-2 text-right"}>
          <button onClick={ this.trackingSetting } className="btn mfc-btn-gray small" type="button">設定</button>
        </div>
        <Modal className="sub-account-modal" isOpen={this.state.isOpenModal} centered={true}>
          <Formsy ref="form" onInvalidSubmit={this.showErrors} onSubmit={this.onSubmit} onValid={this.enableButton} onInvalid={this.disableButton}>
            <ModalHeader toggle={() => this.toggleModal()}>{item.name}</ModalHeader>
            <ModalBody className="checkbox-form">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">取得対象</label>
                <CheckBox className={`col-sm-9 form-inline ${account.is_suspended ? 'disabled' : ''}`} label={"取得対象にする"} id="frm_is_target" name="is_target" value={item.is_target === null ? 0 : item.is_target} disabled={account.is_suspended} />
              </div>
              <hr/>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">使用するタグ</label>
                <div className="col-sm-9 form-inline">
                  {this.data_tags().length === 0 && <span>タグがありません。</span>}
                  {this.data_tags().map((tag, i) => <Tag key={i} value={tag} name={`tags[${i}]`} />)}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label"></label>
                <div className="col-sm-9 form-inline new-tag">
                  <div className="new-tag-input">
                    <input id="sub-account-tag" onKeyPress={this.onKeyPress} type="text" className="form-control" value={this.state.newTagValue} onChange={this.handleChange} placeholder="新しく追加するタグ名を入力" />
                    <div>{this.state.hasError && <FieldError message={this.state.message}/>}</div>
                  </div>
                  <Button className="mfc-btn-gray medium" onClick={this.addNewTag}>追加</Button>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button onClick={this.toggleModal} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
              <button className="btn mfc-btn-blue medium" type="submit">
                {i18n.t('common.save')}
              </button>
            </ModalFooter>
          </Formsy>
        </Modal>
        {hasBottomLine && <hr/>}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    tags: state.user.get('tags')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubAccount)
